export const LANGUAGE_OPTIONS = [
  {
    "id": "zh",
    "label": "Chinese (简体中文)"
  },
  {
    "id": "tw",
    "label": "Chinese (繁體中文)"
  },
  {
    "id": "nl",
    "label": "Dutch (Nederlands)"
  },
  {
    "id": "uk",
    "label": "English (English UK)"
  },
  {
    "id": "us",
    "label": "English (English US)"
  },
  {
    "id": "fr",
    "label": "French (Français)"
  },
  {
    "id": "de",
    "label": "German (Deutsch)"
  },
  {
    "id": "it",
    "label": "Italian (Italiano)"
  },
  {
    "id": "ja",
    "label": "Japanese (日本語)"
  },
  {
    "id": "ko",
    "label": "Korean (한국어)"
  },
  {
    "id": "pt",
    "label": "Portuguese (Português)"
  },
  {
    "id": "ru",
    "label": "Russian (Русский)"
  },
  {
    "id": "es",
    "label": "Spanish (Español)"
  }
]

export const APP_NAMES = {
  "paper": "Paper",
  "meeting": "Meeting",
  "learning": "Learning",
  "memo": "Memo",
  "daily": "Daily",
  "knowledge": "Knowledge Base",
  "knowledge base": "Knowledge Base"
}

export const LANGUAGE_PACKS = {
  "zh": {
    "appUi": {
      "myFiles": "我的文件",
      "all": "全部",
      "allSources": "所有来源",
      "favorite": "收藏",
      "recentDeleted": "回收站",
      "search": "搜索",
      "createFolder": "新建文件夹",
      "importPdf": "导入 PDF",
      "importTemplate": "导入模板",
      "importData": "导入数据",
      "importBooks": "导入书籍",
      "upload": "上传",
      "modifyTime": "修改时间",
      "createTime": "创建时间",
      "name": "名称",
      "desc": "倒序",
      "asc": "正序",
      "listView": "列表",
      "gridView": "网格",
      "empty": "暂无数据",
      "item": "项",
      "page": "页",
      "selectedPrefix": "已选择",
      "selectedSuffix": "项",
      "cancel": "取消",
      "ok": "确定",
      "more": "更多",
      "download": "下载",
      "rename": "重命名",
      "move": "移动",
      "encrypt": "加密",
      "decrypt": "取消加密",
      "encrypted": "已加密",
      "unfavorite": "取消收藏",
      "delete": "删除",
      "back": "返回",
      "recordings": "录音",
      "allRecordings": "全部录音",
      "transcript": "录音转文本",
      "pageGrid": "页面列表",
      "zoomIn": "放大",
      "zoomOut": "缩小",
      "close": "关闭",
      "expand": "展开",
      "collapse": "收起",
      "open": "打开",
      "clear": "清除",
      "downloadList": "下载列表",
      "uploadList": "上传列表",
      "chooseFormat": "选择下载格式",
      "notice": "提示",
      "loading": "加载中",
      "uploading": "上传中",
      "uploadDone": "上传完成",
      "uploadFailed": "上传失败",
      "continueUpload": "继续上传",
      "uploadFileSizeLimit": "文件大小超过500M限制",
      "uploadTypeNotSupported": "上传文件格式不支持",
      "loadFailed": "加载失败",
      "detailLoadFailed": "解析失败，请重试",
      "dataLoadFailed": "{app} 数据加载失败，请稍后重试",
      "retry": "重试",
      "passwordTitle": "输入密码",
      "passwordPlaceholder": "请输入密码",
      "passwordHide": "隐藏密码",
      "passwordShow": "显示密码",
      "passwordConfirming": "验证中",
      "passwordRequired": "请输入密码",
      "passwordWrong": "密码错误，请重新输入密码！",
      "passwordCryptoUnsupported": "当前浏览器不支持密码加密",
      "verifying": "验证中",
      "readingProgress": "阅读进度",
      "noReadingProgress": "暂无阅读进度",
      "bookmarks": "书签",
      "highlights": "高亮",
      "annotations": "手写批注",
      "noBookmarks": "暂无书签",
      "noHighlights": "暂无高亮",
      "noAnnotations": "暂无手写批注",
      "learningAnnotationsEmptyDownload": "\u6279\u6ce8\u4e3a\u7a7a\uff0c\u6682\u65f6\u4e0d\u652f\u6301\u4e0b\u8f7d",
      "noTranscript": "暂无录音文本。",
      "transcriptLoading": "转写文本加载中...",
      "transcriptPending": "该录音的文本文件地址已返回，文本内容将在正式接口补齐后展示。",
      "chooseDownloadableFile": "请选择可下载的文件",
      "foldersNotDownloadable": "文件夹和模板不支持下载，请选择文件",
      "downloadPreparing": "准备下载",
      "downloading": "下载中",
      "downloadDone": "下载完成",
      "downloadFailed": "下载失败",
      "savingFile": "保存文件",
      "generatingPdf": "生成 PDF",
      "packingZip": "打包 ZIP",
      "continueDownload": "继续下载",
      "imageReadFailed": "图片读取失败，请点击重试",
      "maxBatchDownload": "单次下载最多支持 {count} 个文件，请分批下载。",
      "maxRunningDownload": "当前最多只能同时下载 {count} 个任务，请等待部分任务完成后再下载",
      "fakeTip": "接口暂未开放，已用假接口占位",
      "today": "今天",
      "todo": "待办",
      "tasks": "任务",
      "notes": "笔记",
      "month": "月",
      "week": "周",
      "day": "日",
      "allDay": "全部日期",
      "allStatus": "全部状态",
      "finished": "已完成",
      "unfinished": "未完成",
      "dailyDateFormat": "{year} 年 {month} 月 {day} 日",
      "yearFormat": "{year} 年",
      "monthFormat": "{month} 月",
      "weekdays": [
        "日",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六"
      ]
    },
    "login": {
      "login_account": "登录账号",
      "email": "邮箱",
      "phone": "手机",
      "forget_password": "忘记密码",
      "login": "登录",
      "email_error": "邮箱格式错误",
      "password_error": "请输入至少 8 位密码",
      "email_tips": "请输入您的邮箱",
      "phone_tips": "请输入您的手机号",
      "password_tips": "请输入至少 8 位密码",
      "update_password_tips": "修改密码或注册需在 Viwoods 设备上操作",
      "return_login": "返回登录",
      "password_reqired": "密码必填",
      "email_reqired": "邮箱必填",
      "phone_reqired": "手机号必填",
      "please_choose": "区号",
      "please_choose_area": "请选择区号",
      "sms_login": "验证码登录",
      "password_login": "密码登录",
      "verification_tips": "请输入短信验证码",
      "enter_password_tips": "请输入您的密码",
      "verification_code": "发送",
      "reSend": "重发",
      "sending": "发送中"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24小时",
          "desc": "上传后24小时内有效"
        },
        {
          "id": "43200",
          "name": "12小时",
          "desc": "上传后12小时内有效"
        },
        {
          "id": "7200",
          "name": "2小时",
          "desc": "上传后2小时内有效"
        },
        {
          "id": "1800",
          "name": "30分钟",
          "desc": "上传后30分钟内有效"
        }
      ],
      "current_device": "当前设备",
      "choose_device": "选择设备",
      "choose_paper_import": "选择导入类型",
      "choose_language": "选择语言",
      "exit": "退出",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
    "other_name": "其他",
      "name": "名称",
      "type": "类型",
      "size": "大小",
      "time": "到期时间",
      "operation": "操作",
      "download": "下载",
      "delete": "删除",
      "del": "删除",
      "import": "导入",
      "return": "返回上一级",
      "search_all": "搜索全部文件",
      "selected": "已选中",
      "selected_file": "个文件/文件夹",
      "file": "文件",
      "folder": "文件夹",
      "no_data": "暂无数据",
      "confirm_delete": "确认删除",
      "confirm_delete_file": "确认删除文件吗？",
      "device_number": "序列号",
      "send_to": "导入列表",
      "download_list": "下载列表",
      "scan": "扫码或输入地址",
      "share": "分享",
      "download_code": "下载二维码",
      "copy_link": "复制链接",
      "share_tips": "注：分享的链接/二维码有效期为12小时",
      "choose_format": "选择格式",
      "please_choose": "请选择文件夹或者文件",
      "please_choose_format": "请选择格式",
      "format_not_exists": "该格式的文件不存在",
      "copy_success": "复制成功",
      "copy_fail": "复制失败",
      "close_download_tips": "有正在下载的文件，不能关闭列表。",
      "choose_send_device": "请选择同步的设备",
      "send_success": "同步成功",
      "send_fail": "同步出错",
      "cancel": "取消",
      "ok": "确认",
      "send": "同步",
      "no_device": "暂无设备，请在机器上重新登录，即可自动添加设备",
      "current_no_device": "暂无设备",
      "current_device_tips": "当前设备",
      "send_loading_text": "同步中",
      "loading_text": "加载中",
      "send_error": "同步失败",
      "try_download": "重试",
      "downloading": "下载中",
      "error": "服务异常",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "提示：为保证用户数据的隐私安全，上传的文件%s后自动清空",
      "sync": "同步",
      "max_size": "文件的大小不能超过400M",
      "file_time": "文件有效时间",
      "language": "语言",
      "device_name": "设备名称",
      "support_png": "只支持png格式",
      "share_to": "链接复制成功，赶紧分享给朋友吧！",
      "create_code": "生成二维码",
      "so": "等文件",
      "valid": "链接/二维码有效期为 12 小时",
      "download_phone": "下载到手机",
      "yes": "知道了",
      "format_error": "不支持该格式的文件",
      "source": "文件来源",
      "apk_share": "分享",
      "export": "导出",
      "sync_desc": "同步说明",
      "sync_detail": "文件来源为“AiPaper 导出（ViTransfer > 导出）”支持同步，“AiPaper分享”的文件不支持同步。",
      "confirm_exit": "是否确认退出登录？",
      "exit_logo": "密码已更改，请重新登录",
    "picture_name": "图片"
    },
    "trashLabel": "回收站"
  },
  "tw": {
    "appUi": {
      "myFiles": "我的檔案",
      "all": "全部",
      "allSources": "所有來源",
      "favorite": "收藏",
      "recentDeleted": "回收站",
      "search": "搜尋",
      "createFolder": "新增資料夾",
      "importPdf": "匯入 PDF",
      "importTemplate": "匯入模板",
      "importData": "匯入資料",
      "importBooks": "匯入書籍",
      "upload": "上傳",
      "modifyTime": "修改時間",
      "createTime": "建立時間",
      "name": "名稱",
      "desc": "倒序",
      "asc": "正序",
      "listView": "列表",
      "gridView": "網格",
      "empty": "暫無資料",
      "item": "項",
      "page": "頁",
      "selectedPrefix": "已選擇",
      "selectedSuffix": "項",
      "cancel": "取消",
      "ok": "確定",
      "more": "更多",
      "download": "下載",
      "rename": "重新命名",
      "move": "移動",
      "encrypt": "加密",
      "decrypt": "取消加密",
      "encrypted": "已加密",
      "unfavorite": "取消收藏",
      "delete": "刪除",
      "back": "返回",
      "recordings": "錄音",
      "allRecordings": "全部錄音",
      "transcript": "錄音轉文本",
      "pageGrid": "頁面列表",
      "zoomIn": "放大",
      "zoomOut": "縮小",
      "close": "關閉",
      "expand": "展開",
      "collapse": "收起",
      "open": "打開",
      "clear": "清除",
      "downloadList": "下載列表",
      "uploadList": "上傳列表",
      "chooseFormat": "選擇下載格式",
      "notice": "提示",
      "loading": "加載中",
      "uploading": "上傳中",
      "uploadDone": "上傳完成",
      "uploadFailed": "上傳失敗",
      "continueUpload": "繼續上傳",
      "uploadFileSizeLimit": "檔案大小超過500M限制",
      "uploadTypeNotSupported": "上傳檔案格式不支援",
      "loadFailed": "加載失敗",
      "detailLoadFailed": "解析失敗，請重試",
      "dataLoadFailed": "{app} 資料加載失敗，請稍後重試",
      "retry": "重試",
      "passwordTitle": "輸入密碼",
      "passwordPlaceholder": "請輸入密碼",
      "passwordHide": "隱藏密碼",
      "passwordShow": "顯示密碼",
      "passwordConfirming": "驗證中",
      "passwordRequired": "請輸入密碼",
      "passwordWrong": "密碼錯誤，請重新輸入！",
      "passwordCryptoUnsupported": "當前瀏覽器不支援密碼加密",
      "verifying": "驗證中",
      "readingProgress": "閱讀進度",
      "noReadingProgress": "暫無閱讀進度",
      "bookmarks": "書籤",
      "highlights": "高亮",
      "annotations": "手寫批註",
      "noBookmarks": "暫無書籤",
      "noHighlights": "暫無高亮",
      "noAnnotations": "暫無手寫批註",
      "learningAnnotationsEmptyDownload": "\u6279\u8a3b\u70ba\u7a7a\uff0c\u66ab\u6642\u4e0d\u652f\u63f4\u4e0b\u8f09",
      "noTranscript": "暫無錄音文本。",
      "transcriptLoading": "轉寫文本加載中...",
      "transcriptPending": "該錄音的文本檔案位址已返回，文本內容將在正式接口補齊後顯示。",
      "chooseDownloadableFile": "請選擇可下載的檔案",
      "foldersNotDownloadable": "資料夾和模板不支援下載，請選擇檔案",
      "downloadPreparing": "準備下載",
      "downloading": "下載中",
      "downloadDone": "下載完成",
      "downloadFailed": "下載失敗",
      "savingFile": "儲存檔案",
      "generatingPdf": "產生 PDF",
      "packingZip": "打包 ZIP",
      "continueDownload": "繼續下載",
      "imageReadFailed": "圖片讀取失敗，請點擊重試",
      "maxBatchDownload": "單次下載操作不能超過{count}個",
      "maxRunningDownload": "目前最多只能同時下載 {count} 個任務，請等待部分任務完成後再下載",
      "fakeTip": "This API is not available yet.",
      "today": "今天",
      "todo": "待辦",
      "tasks": "任務",
      "notes": "筆記",
      "month": "月",
      "week": "週",
      "day": "日",
      "allDay": "全部日期",
      "allStatus": "全部狀態",
      "finished": "已完成",
      "unfinished": "未完成",
      "dailyDateFormat": "{year} 年 {month} 月 {day} 日",
      "yearFormat": "{year} 年",
      "monthFormat": "{month} 月",
      "weekdays": [
        "日",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六"
      ]
    },
    "login": {
      "login_account": "登入帳號",
      "email": "信箱",
      "phone": "手機",
      "forget_password": "忘記密碼",
      "login": "登入",
      "email_error": "信箱格式錯誤",
      "password_error": "請輸入至少 8 位密碼",
      "email_tips": "請輸入您的信箱",
      "phone_tips": "請輸入您的手機號",
      "password_tips": "請輸入至少 8 位密碼",
      "update_password_tips": "修改密碼或註冊需在 Viwoods 設備上操作",
      "return_login": "返回登入",
      "password_reqired": "密碼必填",
      "email_reqired": "信箱必填",
      "phone_reqired": "手機號必填",
      "please_choose": "區號",
      "please_choose_area": "請選擇區號",
      "sms_login": "驗證碼登入",
      "password_login": "密碼登入",
      "verification_tips": "請輸入簡訊驗證碼",
      "enter_password_tips": "請輸入您的密碼",
      "verification_code": "發送",
      "reSend": "重新發送",
      "sending": "發送中"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24小時",
          "desc": "上傳後24小時內有效"
        },
        {
          "id": "43200",
          "name": "12小時",
          "desc": "上傳後12小時內有效"
        },
        {
          "id": "7200",
          "name": "2小時",
          "desc": "上傳後2小時內有效"
        },
        {
          "id": "1800",
          "name": "30分鐘",
          "desc": "上傳後30分鐘內有效"
        }
      ],
      "current_device": "當前設備",
      "choose_device": "選擇設備",
      "choose_paper_import": "選擇導入類型",
      "choose_language": "選擇語言",
      "exit": "退出",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
    "other_name": "其他",
      "name": "名稱",
      "type": "類型",
      "size": "大小",
      "time": "到期時間",
      "operation": "操作",
      "download": "下載",
      "delete": "刪除",
      "del": "刪除",
      "import": "導入",
      "return": "返回上一级",
      "search_all": "搜索全部文件",
      "selected": "已選中",
      "selected_file": "個文件/文件夾",
      "file": "文件",
      "folder": "文件夾",
      "no_data": "暫無數據",
      "confirm_delete": "確認刪除",
      "confirm_delete_file": "確認刪除文件嗎？",
      "device_number": "序列號",
      "send_to": "導入列表",
      "download_list": "下載列表",
      "scan": "掃碼或輸入地址",
      "share": "分享",
      "download_code": "下載二維碼",
      "copy_link": "複製鏈接",
      "share_tips": "註：分享的鏈接/二維碼有效期為12小時",
      "choose_format": "選擇格式",
      "please_choose": "請選擇文件夾或者文件",
      "please_choose_format": "請選擇格式",
      "format_not_exists": "該格式的文件不存在",
      "copy_success": "複製成功",
      "copy_fail": "複製失敗",
      "close_download_tips": "有正在下載的文件，不能關閉列表。",
      "choose_send_device": "請選擇同步的設備",
      "send_success": "同步成功",
      "send_fail": "同步出錯",
      "cancel": "取消",
      "ok": "確認",
      "send": "同步",
      "no_device": "暫無設備，請在機器上重新登錄，即可自動添加設備",
      "current_no_device": "暫無設備",
      "current_device_tips": "當前設備",
      "send_loading_text": "同步中",
      "loading_text": "加載中",
      "send_error": "同步失敗",
      "try_download": "重試",
      "downloading": "下載中",
      "error": "服務異常",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "提示：為保證用戶數據的隱私安全，上傳的文件%s後自動清空",
      "sync": "同步",
      "max_size": "文件的大小不能超過400M",
      "file_time": "文件有效時間",
      "language": "語言",
      "device_name": "設備名稱",
      "support_png": "只支持png格式",
      "share_to": "鏈接複製成功，趕快分享給朋友吧！",
      "create_code": "生成二維碼",
      "so": "等文件",
      "valid": "鏈接/二維碼有效期為 12 小時",
      "download_phone": "下載到手機",
      "yes": "知道了",
      "format_error": "不支持該格式的文件",
      "source": "文件來源",
      "apk_share": "分享",
      "export": "導出",
      "sync_desc": "同步說明",
      "sync_detail": "文件來源為“AiPaper 導出（ViTransfer > 導出）”支持同步，“AiPaper分享”的文件不支持同步。",
      "confirm_exit": "是否確認退出登錄？",
      "exit_logo": "密碼已更改，請重新登入",
    "picture_name": "圖片"
    },
    "trashLabel": "回收站"
  },
  "nl": {
    "appUi": {
      "myFiles": "Mijn bestanden",
      "all": "Alles",
      "allSources": "Alle bronnen",
      "favorite": "Favorieten",
      "recentDeleted": "Onlangs verwijderd",
      "search": "Zoeken",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "Sjabloon importeren",
      "importData": "Gegevens importeren",
      "importBooks": "Boeken importeren",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "Geen gegevens",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "Annuleren",
      "ok": "OK",
      "more": "More",
      "download": "Downloaden",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "Terug",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "Sluiten",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "Downloadformaat kiezen",
      "notice": "Notice",
      "loading": "Laden",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "De bestandsgrootte overschrijdt de limiet van 500 MB.",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "Opnieuw",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "learningAnnotationsEmptyDownload": "No annotations. Download is not supported yet.",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "Vandaag",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "Zo",
        "Ma",
        "Di",
        "Wo",
        "Do",
        "Vr",
        "Za"
      ]
    },
    "login": {
      "login_account": "Account aanmelden",
      "email": "E-mail",
      "phone": "Telefoon",
      "forget_password": "Wachtwoord vergeten",
      "login": "Aanmelden",
      "email_error": "E-mailfout",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "Voer uw e-mail in",
      "phone_tips": "Voer uw telefoonnummer in",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Werk het wachtwoord bij of registreer op een Viwoods-apparaat",
      "return_login": "Terug",
      "password_reqired": "Wachtwoord verplicht",
      "email_reqired": "E-mail verplicht",
      "phone_reqired": "Telefoon verplicht",
      "please_choose": "Code",
      "please_choose_area": "Kies netnummer",
      "sms_login": "Inloggen met verificatiecode",
      "password_login": "Inloggen met wachtwoord",
      "verification_tips": "Voer de SMS-code in",
      "enter_password_tips": "Voer uw wachtwoord in",
      "verification_code": "Verstuur",
      "reSend": "Opnieuw verzenden",
      "sending": "Verzenden"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24 uur",
          "desc": "Vervalt 24 uur na uploaden"
        },
        {
          "id": "43200",
          "name": "12 uur",
          "desc": "Verloopt 12 uur na upload"
        },
        {
          "id": "7200",
          "name": "2 uur",
          "desc": "Vervalt 2 uur na uploaden"
        },
        {
          "id": "1800",
          "name": "30 minuten",
          "desc": "Vervalt 30 minuten na uploaden"
        }
      ],
      "current_device": "huidige apparaatnaam",
      "choose_device": "kies apparaat",
      "choose_paper_import": "kies type importpapier",
      "choose_language": "kies taal",
      "exit": "Verlaten",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
      "other_name": "Overig",
      "name": "Naam",
      "type": "Type",
      "size": "Grootte",
      "time": "Vervaldatum",
      "operation": "Werking",
      "download": "Downloaden",
      "delete": "Verwijderen",
      "import": "Importeren",
      "return": "Terug Pre",
      "search_all": "Alle bestanden zoeken",
      "selected": "",
      "selected_file": "geselecteerde bestanden/mappen",
      "file": "bestand",
      "folder": "map",
      "no_data": "geen data",
      "confirm_delete": "Verwijderen bevestigen",
      "confirm_delete_file": "bestand verwijderen bevestigen?",
      "send_to": "importlijst",
      "download_list": "downloadlijst",
      "device_number": "apparaatnummer",
      "scan": "Scan de code of voer het adres in",
      "share": "Delen",
      "download_code": "Downloaden",
      "copy_link": "Link kopiëren",
      "share_tips": "Opmerking: de gedeelde link/QR-code is 24 uur geldig.",
      "choose_format": "formaat kiezen",
      "please_choose_format": "Kies formaat",
      "format_not_exists": "Het formaat bestaat niet",
      "copy_success": "Succes bij kopiëren",
      "copy_fail": "Kopiëren mislukt",
      "close_download_tips": "Er worden bestanden gedownload en de lijst kan niet worden gesloten.",
      "choose_send_device": "Kies een synchronisatieapparaat",
      "send_success": "Synchronisatie geslaagd",
      "send_fail": "Synchronisatie mislukt",
      "cancel": "Annuleren",
      "ok": "Bevestig",
      "send": "Synchroniseren",
      "no_device": "Meld je opnieuw aan op de machine om het apparaat automatisch toe te voegen",
      "current_no_device": "geen apparaat",
      "current_device_tips": "huidig apparaat",
      "send_loading_text": "Synchroniseren",
      "loading_text": "Laden",
      "send_error": "synchronisatie mislukt",
      "try_download": "opnieuw proberen",
      "downloading": "downloaden",
      "error": "serverfout",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "Opmerking: om de privacy en veiligheid van gebruikersgegevens te waarborgen, worden geüploade bestanden automatisch gewist na %s.",
      "sync": "Synchroniseren",
      "max_size": "Het bestand is groter dan 100MB en kan niet worden geüpload.",
      "file_time": "Bestand vervalt in",
      "language": "Taal",
      "device_name": "Apparaatnaam",
      "support_png": "Ondersteunt alleen PNG-formaat",
      "share_to": "De link is succesvol gekopieerd, deel deze snel met je vrienden",
      "create_code": "QR-code genereren",
      "so": "Wachten op bestanden",
      "valid": "De link/QR code is geldig voor 12 uur",
      "download_phone": "Download naar mobiele telefoon",
      "yes": "Begrepen",
      "format_error": "Bestanden in dit formaat worden niet ondersteund",
      "source": "Bron",
      "apk_share": "Delen",
      "export": "Exporteren",
      "sync_desc": "synchronisatie-instructies",
      "sync_detail": "Bestanden afkomstig van \"AiPaper Exporteren (ViTransfer > Exporteren)\" ondersteunen synchronisatie, terwijl bestanden van \"AiPaper Delen\" geen synchronisatie ondersteunen.",
      "confirm_exit": "Weet u zeker dat u wilt uitloggen?",
      "exit_logo": "Het wachtwoord is gewijzigd. Log alstublieft opnieuw in.",
      "picture_name": "Afbeelding"
    },
    "trashLabel": "Prullenbak"
  },
  "uk": {
    "appUi": {
      "myFiles": "My Files",
      "all": "All",
      "allSources": "All sources",
      "favorite": "Favorites",
      "recentDeleted": "Recently deleted",
      "search": "Search",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "Import Template",
      "importData": "Import Data",
      "importBooks": "Import Books",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "No data",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "Cancel",
      "ok": "OK",
      "more": "More",
      "download": "Download",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "Back",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "Close",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "Choose download format",
      "notice": "Notice",
      "loading": "Loading",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "File size exceeds the 500 MB limit.",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "Retry",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "Today",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ]
    },
    "login": {
      "login_account": "Login Account",
      "email": "Email",
      "phone": "Phone",
      "forget_password": "Forgot Password",
      "login": "Login",
      "email_error": "Email Error",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "Please enter your email",
      "phone_tips": "Please enter your phone",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Update password or register on a Viwoods device",
      "return_login": "Back",
      "password_reqired": "Password required",
      "email_reqired": "Email required",
      "phone_reqired": "Phone required",
      "please_choose": "Code",
      "please_choose_area": "Please choose area code",
      "sms_login": "Verification Code Login",
      "password_login": "Password Login",
      "verification_tips": "Please enter SMS code",
      "enter_password_tips": "Please enter your password",
      "verification_code": "Send",
      "reSend": "Resend",
      "sending": "Sending"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24 Hours",
          "desc": "Expires 24 hours after upload"
        },
        {
          "id": "43200",
          "name": "12 Hours",
          "desc": "Expires 12 hours after upload"
        },
        {
          "id": "7200",
          "name": "2 Hours",
          "desc": "Expires 2 hours after upload"
        },
        {
          "id": "1800",
          "name": "30 Minutes",
          "desc": "Expires 30 minutes after upload"
        }
      ],
      "current_device": "current device name",
      "choose_device": "choose device",
      "choose_paper_import": "choose import paper type",
      "choose_language": "choose language",
      "exit": "Exit",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
      "other_name": "Other",
      "name": "Name",
      "type": "Type",
      "size": "Size",
      "time": "Expiration date",
      "operation": "Operation",
      "download": "Download",
      "delete": "Delete",
      "del": "Del",
      "import": "Import",
      "return": "Return Pre",
      "search_all": "Search all file",
      "selected": "",
      "selected_file": " files/folders selected",
      "file": "file",
      "folder": "folder",
      "no_data": "no data",
      "confirm_delete": "confirm delete",
      "confirm_delete_file": "confirm delete file？",
      "send_to": "import list",
      "download_list": "download list",
      "device_number": "device number",
      "scan": "Scan the code or enter the address",
      "share": "Share",
      "download_code": "Download",
      "copy_link": "Copy Link",
      "share_tips": "Note: The shared link/QR code is valid for 12 hours",
      "choose_format": "choose format",
      "please_choose": "Please choose folder or file",
      "please_choose_format": "Please choose format",
      "format_not_exists": "The format not exists",
      "copy_success": "Copy success",
      "copy_fail": "Copy fail",
      "close_download_tips": "There are files being downloaded and the list cannot be closed.",
      "choose_send_device": "please choose sync device",
      "send_success": "Sync success",
      "send_fail": "Sync fail",
      "cancel": "Cancel",
      "ok": "Confirm",
      "send": "Sync",
      "no_device": "Please log in again on the machine to automatically add the device",
      "current_no_device": "no device",
      "current_device_tips": "current device",
      "send_loading_text": "Syncing",
      "loading_text": "Loading",
      "send_error": "sync fail",
      "try_download": "retry",
      "downloading": "downloading",
      "error": "server error",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "Note: To ensure the privacy and security of user data, uploaded files will be automatically cleared after %s.",
      "sync": "Sync",
      "max_size": "The file size exceeds 400MB and cannot be uploaded.",
      "file_time": "File Expires in",
      "language": "Language",
      "device_name": "Device Name",
      "support_png": "Only supports PNG format",
      "share_to": "The link has been copied successfully, please share it with your friends quickly",
      "create_code": "Generate QR code",
      "so": "Waiting for files",
      "valid": "The link/QR code is valid for 12 hours",
      "download_phone": "Download to mobile phone",
      "yes": "Yes",
      "format_error": "Files in this format are not supported",
      "source": "File Source",
      "apk_share": "sharing",
      "export": "export",
      "sync_desc": "Help of Sync",
      "sync_detail": "Files originating from \"AiPaper Export (ViTransfer > Export)\" support synchronization, while files from \"AiPaper Sharing\" do not support synchronization.",
      "confirm_exit": "Are you sure you want to log out?",
      "exit_logo": "Password has been changed. Please log in again.",
      "picture_name": "Picture"
    },
    "trashLabel": "Trash"
  },
  "us": {
    "appUi": {
      "myFiles": "My Files",
      "all": "All",
      "allSources": "All sources",
      "favorite": "Favorites",
      "recentDeleted": "Recently deleted",
      "search": "Search",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "Import Template",
      "importData": "Import Data",
      "importBooks": "Import Books",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "No data",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "Cancel",
      "ok": "OK",
      "more": "More",
      "download": "Download",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "Back",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "Close",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "Choose download format",
      "notice": "Notice",
      "loading": "Loading",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "File size exceeds the 500 MB limit.",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "Retry",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "Today",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ]
    },
    "login": {
      "login_account": "Login Account",
      "email": "Email",
      "phone": "Phone",
      "forget_password": "Forgot Password",
      "login": "Login",
      "email_error": "Email Error",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "Please enter your email",
      "phone_tips": "Please enter your phone",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Update password or register on a Viwoods device",
      "return_login": "Back",
      "password_reqired": "Password required",
      "email_reqired": "Email required",
      "phone_reqired": "Phone required",
      "please_choose": "Code",
      "please_choose_area": "Please choose area code",
      "sms_login": "Verification Code Login",
      "password_login": "Password Login",
      "verification_tips": "Please enter SMS code",
      "enter_password_tips": "Please enter your password",
      "verification_code": "Send",
      "reSend": "Resend",
      "sending": "Sending"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24 Hours",
          "desc": "Expires 24 hours after upload"
        },
        {
          "id": "43200",
          "name": "12 Hours",
          "desc": "Expires 12 hours after upload"
        },
        {
          "id": "7200",
          "name": "2 Hours",
          "desc": "Expires 2 hours after upload"
        },
        {
          "id": "1800",
          "name": "30 Minutes",
          "desc": "Expires 30 minutes after upload"
        }
      ],
      "current_device": "current device name",
      "choose_device": "choose device",
      "choose_paper_import": "choose import paper type",
      "choose_language": "choose language",
      "exit": "Exit",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
      "other_name": "Other",
      "name": "Name",
      "type": "Type",
      "size": "Size",
      "time": "Expiration date",
      "operation": "Operation",
      "download": "Download",
      "delete": "Delete",
      "del": "Del",
      "import": "Import",
      "return": "Return Pre",
      "search_all": "Search all file",
      "selected": "",
      "selected_file": " files/folders selected",
      "file": "file",
      "folder": "folder",
      "no_data": "no data",
      "confirm_delete": "confirm delete",
      "confirm_delete_file": "confirm delete file？",
      "send_to": "import list",
      "download_list": "download list",
      "device_number": "device number",
      "scan": "Scan the code or enter the address",
      "share": "Share",
      "download_code": "Download",
      "copy_link": "Copy Link",
      "share_tips": "Note: The shared link/QR code is valid for 12 hours",
      "choose_format": "choose format",
      "please_choose": "Please choose folder or file",
      "please_choose_format": "Please choose format",
      "format_not_exists": "The format not exists",
      "copy_success": "Copy success",
      "copy_fail": "Copy fail",
      "close_download_tips": "There are files being downloaded and the list cannot be closed.",
      "choose_send_device": "please choose sync device",
      "send_success": "Sync success",
      "send_fail": "Sync fail",
      "cancel": "Cancel",
      "ok": "Confirm",
      "send": "Sync",
      "no_device": "Please log in again on the machine to automatically add the device",
      "current_no_device": "no device",
      "current_device_tips": "current device",
      "send_loading_text": "Syncing",
      "loading_text": "Loading",
      "send_error": "sync fail",
      "try_download": "retry",
      "downloading": "downloading",
      "error": "server error",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "Note: To ensure the privacy and security of user data, uploaded files will be automatically cleared after %s.",
      "sync": "Sync",
      "max_size": "The file size exceeds 400MB and cannot be uploaded.",
      "file_time": "File Expires in",
      "language": "Language",
      "device_name": "Device Name",
      "support_png": "Only supports PNG format",
      "share_to": "The link has been copied successfully, please share it with your friends quickly",
      "create_code": "Generate QR code",
      "so": "Waiting for files",
      "valid": "The link/QR code is valid for 12 hours",
      "download_phone": "Download to mobile phone",
      "yes": "Yes",
      "format_error": "Files in this format are not supported",
      "source": "File Source",
      "apk_share": "sharing",
      "export": "export",
      "sync_desc": "Help of Sync",
      "sync_detail": "Files originating from \"AiPaper Export (ViTransfer > Export)\" support synchronization, while files from \"AiPaper Sharing\" do not support synchronization.",
      "confirm_exit": "Are you sure you want to log out?",
      "exit_logo": "Password has been changed. Please log in again.",
      "picture_name": "Picture"
    },
    "trashLabel": "Trash"
  },
  "fr": {
    "appUi": {
      "myFiles": "Mes fichiers",
      "all": "Tout",
      "allSources": "Toutes les sources",
      "favorite": "Favoris",
      "recentDeleted": "Supprimés récemment",
      "search": "Rechercher",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "Importer le modèle",
      "importData": "Importer les données",
      "importBooks": "Importer des livres",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "Aucune donnée",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "Annuler",
      "ok": "OK",
      "more": "More",
      "download": "Télécharger",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "Retour",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "Fermer",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "Choisir le format",
      "notice": "Notice",
      "loading": "Chargement",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "La taille du fichier dépasse la limite de 500 Mo.",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "Réessayer",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "Aujourd’hui",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "Dim",
        "Lun",
        "Mar",
        "Mer",
        "Jeu",
        "Ven",
        "Sam"
      ]
    },
    "login": {
      "login_account": "Compte de connexion",
      "email": "E-mail",
      "phone": "Telephone",
      "forget_password": "Mot de passe oublie",
      "login": "Connexion",
      "email_error": "Erreur e-mail",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "Veuillez saisir votre e-mail",
      "phone_tips": "Veuillez saisir votre telephone",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Mettez a jour le mot de passe ou inscrivez-vous sur un appareil Viwoods",
      "return_login": "Retour",
      "password_reqired": "Mot de passe requis",
      "email_reqired": "E-mail requis",
      "phone_reqired": "Telephone requis",
      "please_choose": "Code",
      "please_choose_area": "Veuillez choisir lindicatif",
      "sms_login": "Connexion par code",
      "password_login": "Connexion par mot de passe",
      "verification_tips": "Veuillez saisir le code SMS",
      "enter_password_tips": "Veuillez saisir votre mot de passe",
      "verification_code": "Envoyer",
      "reSend": "Renvoyer",
      "sending": "Envoi"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24 heures",
          "desc": "Expire 24 heures après le téléchargement"
        },
        {
          "id": "43200",
          "name": "12 heures",
          "desc": "Expire 12 heures après le téléchargement"
        },
        {
          "id": "7200",
          "name": "2 heures",
          "desc": "Expire 2 heures après le téléchargement"
        },
        {
          "id": "1800",
          "name": "30 minutes",
          "desc": "Expire 30 minutes après le téléchargement"
        }
      ],
      "current_device": "nom de l'appareil actuel",
      "choose_device": "choisir l'appareil",
      "choose_paper_import": "choisir le type du papier à importer",
      "choose_language": "choisir la langue",
      "exit": "Quitter",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
      "other_name": "Autre",
      "name": "Nom ",
      "type": "Type ",
      "size": "Taille",
      "time": "Temps d'expiration",
      "operation": "Fonctionnement",
      "download": "Télécharger",
      "delete": "Supprimer",
      "import": "Importation",
      "return": "Annuler Pre",
      "search_all": "Rechercher tous les fichiers",
      "selected": "",
      "selected_file": "fichiers/dossiers sélectionnés",
      "file": "fichier",
      "folder": "dossier",
      "no_data": "pas de données",
      "confirm_delete": "confirmer la suppression",
      "confirm_delete_file": "confirmer la suppression du fichier？",
      "send_to": "importer une liste",
      "download_list": "liste des téléchargements",
      "device_number": "numéro de l'appareil",
      "scan": "Scannez le code ou entrez l'adresse",
      "share": "Partager",
      "download_code": "Télécharger",
      "copy_link": "Copier le lien",
      "share_tips": "Remarque : le lien partagé/code QR est valable pendant 24 heures.",
      "choose_format": "choisir le format",
      "please_choose_format": "Veuillez choisir le format",
      "format_not_exists": "Le format n'existe pas",
      "copy_success": "Copie réussie",
      "copy_fail": "Échec de la copie",
      "close_download_tips": "Des fichiers sont en cours de téléchargement et la liste ne peut pas être fermée.",
      "choose_send_device": "Veuillez choisir l'appareil de synchronisation",
      "send_success": "Synchronisation réussie",
      "send_fail": "Échec de la synchronisation",
      "cancel": "Annuler",
      "ok": "Confirmer",
      "send": "Synchronisation",
      "no_device": "Veuillez vous connecter à nouveau sur la machine pour ajouter automatiquement l'appareil.",
      "current_no_device": "pas d'appareil",
      "current_device_tips": "appareil actuel",
      "send_loading_text": "Synchronisation",
      "loading_text": "Chargement",
      "send_error": "échec de la synchronisation",
      "try_download": "réessayer",
      "downloading": "téléchargement",
      "error": "erreur de serveur",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "Remarque : pour garantir la confidentialité et la sécurité des données des utilisateurs, les fichiers téléchargés seront automatiquement effacés après %s.",
      "sync": "Synchronisation",
      "max_size": "La taille du fichier dépasse 400MB et ne peut pas être téléchargée.",
      "file_time": "Le fichier expire dans",
      "language": "la langue",
      "device_name": "Nom de l'appareil",
      "support_png": "Seul le format PNG est supporté",
      "share_to": "Le lien a été copié avec succès, dépêchez - vous de le partager avec vos amis!",
      "create_code": "Générer un Code QR",
      "so": "Documents égaux",
      "valid": "Le lien / Code QR est valable 12 heures",
      "download_phone": "télécharger sur mobile",
      "yes": "savoir",
      "format_error": "Les fichiers dans ce format ne sont pas pris en charge",
      "source": "Sources",
      "apk_share": "partager",
      "export": "export",
      "sync_desc": "instructions de synchronisation",
      "sync_detail": "Les fichiers provenant de « AiPaper Export (ViTransfer > Export) » prennent en charge la synchronisation, tandis que les fichiers de « Partage AiPaper » ne prennent pas en charge la synchronisation.",
      "confirm_exit": "Êtes-vous sûr de vouloir vous déconnecter?",
      "exit_logo": "Le mot de passe a été changé. Veuillez vous reconnecter.",
      "picture_name": "Image"
    },
    "trashLabel": "Corbeille"
  },
  "de": {
    "appUi": {
      "myFiles": "Meine Dateien",
      "all": "Alle",
      "allSources": "Alle Quellen",
      "favorite": "Favoriten",
      "recentDeleted": "Kürzlich gelöscht",
      "search": "Suchen",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "Vorlage importieren",
      "importData": "Daten importieren",
      "importBooks": "Bücher importieren",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "Keine Daten",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "Abbrechen",
      "ok": "OK",
      "more": "More",
      "download": "Herunterladen",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "Zurück",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "Schließen",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "Downloadformat wählen",
      "notice": "Notice",
      "loading": "Wird geladen",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "Die Dateigröße überschreitet das Limit von 500 MB.",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "Erneut versuchen",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "Heute",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
      ]
    },
    "login": {
      "login_account": "Konto anmelden",
      "email": "E-Mail",
      "phone": "Telefon",
      "forget_password": "Passwort vergessen",
      "login": "Anmelden",
      "email_error": "E-Mail-Fehler",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "Bitte E-Mail eingeben",
      "phone_tips": "Bitte Telefonnummer eingeben",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Passwort aktualisieren oder auf einem Viwoods-Geraet registrieren",
      "return_login": "Zurueck",
      "password_reqired": "Passwort erforderlich",
      "email_reqired": "E-Mail erforderlich",
      "phone_reqired": "Telefon erforderlich",
      "please_choose": "Code",
      "please_choose_area": "Bitte Vorwahl waehlen",
      "sms_login": "Login mit Code",
      "password_login": "Login mit Passwort",
      "verification_tips": "Bitte SMS-Code eingeben",
      "enter_password_tips": "Bitte Passwort eingeben",
      "verification_code": "Senden",
      "reSend": "Erneut senden",
      "sending": "Senden"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24 Stunden",
          "desc": "Verfällt 24 Stunden nach Hochladen"
        },
        {
          "id": "43200",
          "name": "12 Stunden",
          "desc": "Verfällt 12 Stunden nach Hochladen"
        },
        {
          "id": "7200",
          "name": "2 Stunden",
          "desc": "Verfällt 2 Stunden nach dem Hochladen"
        },
        {
          "id": "1800",
          "name": "30 Minuten",
          "desc": "Läuft 30 Minuten nach dem Hochladen ab"
        }
      ],
      "current_device": "Aktueller Gerätename",
      "choose_device": "Gerät auswählen",
      "choose_paper_import": "Papiertyp für Import auswählen",
      "choose_language": "Sprache auswählen",
      "exit": "Beenden",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
      "other_name": "Andere",
      "name": "Name",
      "type": "Art",
      "size": "Größe",
      "time": "Ablaufdatum",
      "operation": "Vorgang",
      "download": "Herunterladen",
      "delete": "Löschen",
      "import": "Importieren",
      "return": "Zurück Vor",
      "search_all": "Alle Dateien suchen",
      "selected": "",
      "selected_file": "Ausgewählte Dateien/Ordner",
      "file": "Datei",
      "folder": "Ordner",
      "no_data": "keine Daten",
      "confirm_delete": "Löschen bestätigen",
      "confirm_delete_file": "Löschen der Datei bestätigen",
      "send_to": "importliste",
      "download_list": "liste herunterladen",
      "device_number": "Gerätenummer",
      "scan": "Code einscannen oder Adresse eingeben",
      "share": "Weiterleiten",
      "download_code": "Herunterladen",
      "copy_link": "Link kopieren",
      "share_tips": "Hinweis: Der freigegebene Link/QR-Code ist 24 Stunden gültig.",
      "choose_format": "Format auswählen",
      "please_choose_format": "Bitte Format wählen",
      "format_not_exists": "Format existiert nicht",
      "copy_success": "Kopieren erfolgreich",
      "copy_fail": "Kopieren fehlgeschlagen",
      "close_download_tips": "Dateien werden heruntergeladen und die Liste kann nicht geschlossen werden.",
      "choose_send_device": "Bitte wählen Sie ein Synchronisierungsgerät",
      "send_success": "Synchronisation erfolgreich",
      "send_fail": "Synchronisation fehlgeschlagen",
      "cancel": "Abbrechen",
      "ok": "Bestätigen",
      "send": "Synchronisieren",
      "no_device": "Um das Gerät automatisch hinzuzufügen, melden Sie sich bitte erneut am Computer an.",
      "current_no_device": "kein Gerät",
      "current_device_tips": "aktuelles Gerät",
      "send_loading_text": "Synchronisieren",
      "loading_text": "Laden",
      "send_error": "Synchronisation fehlgeschlagen",
      "try_download": "erneut versuchen",
      "downloading": "Herunterladen",
      "error": "Server-Fehler",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "Hinweis: Hochgeladene Dateien werden nach %s automatisch gelöscht, um den Datenschutz und die Sicherheit der Benutzerdaten zu gewährleisten.",
      "sync": "Synchronisieren",
      "max_size": "Die Datei ist größer als 100MB und kann nicht hochgeladen werden.",
      "file_time": "Datei läuft ab in",
      "language": "Sprache",
      "device_name": "Gerätename",
      "support_png": "Unterstützt nur PNG-Format",
      "share_to": "Der Link wurde erfolgreich kopiert, bitte teilen Sie ihn schnell mit Ihren Freunden",
      "create_code": "QR-Code generieren",
      "so": "Warten auf Dateien",
      "valid": "Der Link/QR-Code ist für 12 Stunden gültig",
      "download_phone": "Download auf Handy",
      "yes": "Hab's",
      "format_error": "Dateien in diesem Format werden nicht unterstützt",
      "source": "Quelle",
      "apk_share": "teilen",
      "export": "export",
      "sync_desc": "synchronisierungsanweisungen",
      "sync_detail": "Dateien, die aus „AiPaper Export (ViTransfer > Export)“ stammen, unterstützen die Synchronisierung, während Dateien aus „AiPaper Teilen“ die Synchronisierung nicht unterstützen.",
      "confirm_exit": "Sind Sie sicher, dass Sie sich abmelden möchten?",
      "exit_logo": "Das Passwort wurde geändert. Bitte melden Sie sich erneut an.",
      "picture_name": "Bild"
    },
    "trashLabel": "Papierkorb"
  },
  "it": {
    "appUi": {
      "myFiles": "I miei file",
      "all": "Tutto",
      "allSources": "Tutte le fonti",
      "favorite": "Preferiti",
      "recentDeleted": "Eliminati di recente",
      "search": "Cerca",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "Importa modello",
      "importData": "Importa dati",
      "importBooks": "Importa libri",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "Nessun dato",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "Annulla",
      "ok": "OK",
      "more": "More",
      "download": "Scarica",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "Indietro",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "Chiudi",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "Scegli formato",
      "notice": "Notice",
      "loading": "Caricamento",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "La dimensione del file supera il limite di 500 MB.",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "Riprova",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "Oggi",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "Dom",
        "Lun",
        "Mar",
        "Mer",
        "Gio",
        "Ven",
        "Sab"
      ]
    },
    "login": {
      "login_account": "Account di accesso",
      "email": "Email",
      "phone": "Telefono",
      "forget_password": "Password dimenticata",
      "login": "Accedi",
      "email_error": "Errore email",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "Inserisci la tua email",
      "phone_tips": "Inserisci il tuo telefono",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Aggiorna la password o registrati su un dispositivo Viwoods",
      "return_login": "Indietro",
      "password_reqired": "Password richiesta",
      "email_reqired": "Email richiesta",
      "phone_reqired": "Telefono richiesto",
      "please_choose": "Codice",
      "please_choose_area": "Scegli il prefisso",
      "sms_login": "Accesso con codice",
      "password_login": "Accesso con password",
      "verification_tips": "Inserisci il codice SMS",
      "enter_password_tips": "Inserisci la password",
      "verification_code": "Invia",
      "reSend": "Invia di nuovo",
      "sending": "Invio"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24 ore",
          "desc": "Scade 24 ore dopo il caricamento"
        },
        {
          "id": "43200",
          "name": "12 ore",
          "desc": "Scade 12 ore dopo il caricamento"
        },
        {
          "id": "7200",
          "name": "2 ore",
          "desc": "Scade 2 ore dopo il caricamento"
        },
        {
          "id": "1800",
          "name": "30 minuti",
          "desc": "Scade 30 minuti dopo il caricamento"
        }
      ],
      "current_device": "nome dispositivo corrente",
      "choose_device": "scegli dispositivo",
      "choose_paper_import": "scegli tipo di carta da importare",
      "choose_language": "scegli lingua",
      "exit": "Esci",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
      "other_name": "Altro",
      "name": "Nome",
      "type": "Tipo",
      "size": "Dimensione",
      "time": "Data di scadenza",
      "operation": "Operazione",
      "download": "Download",
      "delete": "Elimina",
      "import": "Importa",
      "return": "Ritorna Pre",
      "search_all": "Cerca tutti i file",
      "selected": "",
      "selected_file": "file/cartelle selezionati",
      "file": "file",
      "folder": "cartella",
      "no_data": "nessun dato",
      "confirm_delete": "conferma eliminazione",
      "confirm_delete_file": "conferma eliminazione file？",
      "send_to": "elenco di importazione",
      "download_list": "scaricare elenco",
      "device_number": "numero dispositivo",
      "scan": "Scansiona il codice o inserisci l'indirizzo",
      "share": "Condividi",
      "download_code": "Scarica",
      "copy_link": "Copia collegamento",
      "share_tips": "Nota: il collegamento condiviso/codice QR è valido per 24 ore",
      "choose_format": "scegli formato",
      "please_choose_format": "Scegli formato",
      "format_not_exists": "Il formato non esiste",
      "copy_success": "Copia riuscita",
      "copy_fail": "Copia fallita",
      "close_download_tips": "Ci sono file in fase di download e l'elenco non può essere chiuso.",
      "choose_send_device": "scegli dispositivo di sincronizzazione",
      "send_success": "Sincronizzazione riuscita",
      "send_fail": "Sincronizzazione fallita",
      "cancel": "Annulla",
      "ok": "Conferma",
      "send": "Sincronizzazione",
      "no_device": "Accedi di nuovo sul computer per aggiungere automaticamente il dispositivo",
      "current_no_device": "Nessun dispositivo",
      "current_device_tips": "Dispositivo corrente",
      "send_loading_text": "Sincronizzazione",
      "loading_text": "Caricamento",
      "send_error": "Sincronizzazione fallita",
      "try_download": "Riprova",
      "downloading": "Download",
      "error": "Errore del server",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "Nota: Per garantire la privacy e la sicurezza dei dati utente, i file caricati verranno automaticamente cancellati dopo %s.",
      "sync": "Sincronizzazione",
      "max_size": "La dimensione del file supera i 100 MB e non può essere caricata.",
      "file_time": "Il file scade tra",
      "language": "Lingua",
      "device_name": "Nome del dispositivo",
      "support_png": "Supporta solo il formato PNG.",
      "share_to": "Il link è stato copiato con successo, condividilo subito con gli amici!",
      "create_code": "Generare codice 2D",
      "so": "Aspetta i documenti",
      "valid": "Link/codice 2D valido per 12 ore",
      "download_phone": "Scarica sul cellulare",
      "yes": "Lo so",
      "format_error": "File non supportati in questo formato",
      "source": "Fonte",
      "apk_share": "Condividi",
      "export": "Esporta",
      "sync_desc": "istruzioni di sincronizzazione",
      "sync_detail": "I file provenienti da \"Esportazione AiPaper (ViTransfer > Esporta)\" supportano la sincronizzazione, mentre i file da \"Condivisione AiPaper\" non supportano la sincronizzazione.",
      "confirm_exit": "Sei sicuro di voler effettuare il logout?",
      "exit_logo": "La password è stata modificata. Si prega di effettuare nuovamente l'accesso.",
      "picture_name": "Immagine"
    },
    "trashLabel": "Cestino"
  },
  "ja": {
    "appUi": {
      "myFiles": "マイファイル",
      "all": "すべて",
      "allSources": "\u3059\u3079\u3066\u306e\u30bd\u30fc\u30b9",
      "favorite": "お気に入り",
      "recentDeleted": "最近削除",
      "search": "検索",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "テンプレートをインポート",
      "importData": "データをインポート",
      "importBooks": "書籍をインポート",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "データなし",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "キャンセル",
      "ok": "OK",
      "more": "More",
      "download": "ダウンロード",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "戻る",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "閉じる",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "ダウンロード形式を選択",
      "notice": "Notice",
      "loading": "読み込み中",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "ファイルサイズが500MBの上限を超えています。",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "再試行",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "今日",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "日",
        "月",
        "火",
        "水",
        "木",
        "金",
        "土"
      ]
    },
    "login": {
      "login_account": "ログインアカウント",
      "email": "メール",
      "phone": "電話",
      "forget_password": "パスワードを忘れた",
      "login": "ログイン",
      "email_error": "メールエラー",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "メールを入力",
      "phone_tips": "電話番号を入力",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Viwoods デバイスでパスワード更新または登録してください",
      "return_login": "戻る",
      "password_reqired": "パスワード必須",
      "email_reqired": "メール必須",
      "phone_reqired": "電話必須",
      "please_choose": "コード",
      "please_choose_area": "地域コードを選択",
      "sms_login": "認証コードログイン",
      "password_login": "パスワードログイン",
      "verification_tips": "SMS コードを入力",
      "enter_password_tips": "パスワードを入力",
      "verification_code": "送信",
      "reSend": "再送信",
      "sending": "送信中"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24時間",
          "desc": "アップロード後24時間で有効期限切れ"
        },
        {
          "id": "43200",
          "name": "12時間",
          "desc": "アップロード後12時間で有効期限が切れます"
        },
        {
          "id": "7200",
          "name": "2時間",
          "desc": "アップロード後2時間で有効期限切れ"
        },
        {
          "id": "1800",
          "name": "30分",
          "desc": "アップロード後30分で有効期限切れ"
        }
      ],
      "current_device": "現在のデバイス名",
      "choose_device": "デバイスを選択",
      "choose_paper_import": "インポートするペーパーの種類を選択",
      "choose_language": "言語を選択",
      "exit": "終了",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
    "other_name": "その他",
      "name": "名前",
      "type": "種類",
      "size": "サイズ",
      "time": "有効期限",
      "operation": "操作",
      "download": "ダウンロード",
      "delete": "削除",
      "import": "インポート",
      "return": "前に戻る",
      "search_all": "すべてのファイルを検索",
      "selected": "",
      "selected_file": " ファイル/フォルダーが選択されました",
      "file": "ファイル",
      "folder": "フォルダー",
      "no_data": "データがありません",
      "confirm_delete": "削除の確認",
      "confirm_delete_file": "ファイルを削除しますか？",
      "send_to": "インポートリスト",
      "download_list": "ダウンロードリスト",
      "device_number": "デバイス番号",
      "scan": "コードをスキャンするかアドレスを入力してください",
      "share": "共有",
      "download_code": "ダウンロード",
      "copy_link": "リンクをコピー",
      "share_tips": "注意：共有リンク/QRコードの有効期限は24時間です",
      "choose_format": "形式を選択",
      "please_choose_format": "形式を選択してください",
      "format_not_exists": "この形式は存在しません",
      "copy_success": "コピーしました",
      "copy_fail": "コピーに失敗しました",
      "close_download_tips": "ダウンロード中のファイルがあるため、リストを閉じることができません",
      "choose_send_device": "同期するデバイスを選択してください",
      "send_success": "同期が完了しました",
      "send_fail": "同期に失敗しました",
      "cancel": "キャンセル",
      "ok": "確認",
      "send": "同期",
      "no_device": "機器で再度ログインするとデバイスが自動的に追加されます",
      "current_no_device": "デバイスがありません",
      "current_device_tips": "現在のデバイス",
      "send_loading_text": "同期中",
      "loading_text": "読み込み中",
      "send_error": "同期に失敗しました",
      "try_download": "再試行",
      "downloading": "ダウンロード中",
      "error": "サーバーエラー",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "注意：ユーザーデータのプライバシーとセキュリティを確保するため、アップロードされたファイルは%s後に自動的に消去されます",
      "sync": "同期",
      "max_size": "ファイルサイズが100MBを超えているため、アップロードできません",
      "file_time": "ファイルの有効期限まで",
      "language": "言語",
      "device_name": "デバイス名",
      "support_png": "pngフォーマットのみサポート",
      "share_to": "リンクコピー成功、早速友達にシェアしよう！",
      "create_code": "2次元コードを生成する",
      "so": "等ファイル",
      "valid": "リンク/QRコードの有効期間は12時間",
      "download_phone": "携帯電話にダウンロード",
      "yes": "わかりました",
      "format_error": "この形式のファイルはサポートされていません",
      "source": "ソース",
      "apk_share": "共有",
      "export": "エクスポート",
      "sync_desc": "同期の説明",
      "sync_detail": "「AiPaperエクスポート（ViTransfer > エクスポート）」からのファイルは同期をサポートしますが、「AiPaperシェア」のファイルは同期をサポートしません。",
      "confirm_exit": "ログアウトしてもよろしいですか？",
      "exit_logo": "パスワードが変更されました。もう一度ログインしてください。",
    "picture_name": "画像"
    },
    "trashLabel": "ゴミ箱"
  },
  "ko": {
    "appUi": {
      "myFiles": "내 파일",
      "all": "전체",
      "allSources": "\ubaa8\ub4e0 \uc18c\uc2a4",
      "favorite": "즐겨찾기",
      "recentDeleted": "최근 삭제",
      "search": "검색",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "템플릿 가져오기",
      "importData": "데이터 가져오기",
      "importBooks": "책 가져오기",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "데이터 없음",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "취소",
      "ok": "확인",
      "more": "More",
      "download": "다운로드",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "뒤로",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "닫기",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "다운로드 형식 선택",
      "notice": "Notice",
      "loading": "로드 중",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "파일 크기가 500MB 제한을 초과했습니다.",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "다시 시도",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "오늘",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "일",
        "월",
        "화",
        "수",
        "목",
        "금",
        "토"
      ]
    },
    "login": {
      "login_account": "로그인 계정",
      "email": "이메일",
      "phone": "전화",
      "forget_password": "비밀번호 찾기",
      "login": "로그인",
      "email_error": "이메일 오류",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "이메일을 입력하세요",
      "phone_tips": "전화번호를 입력하세요",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Viwoods 기기에서 비밀번호를 변경하거나 등록하세요",
      "return_login": "뒤로",
      "password_reqired": "비밀번호 필수",
      "email_reqired": "이메일 필수",
      "phone_reqired": "전화번호 필수",
      "please_choose": "코드",
      "please_choose_area": "국가 번호 선택",
      "sms_login": "인증코드 로그인",
      "password_login": "비밀번호 로그인",
      "verification_tips": "SMS 코드를 입력하세요",
      "enter_password_tips": "비밀번호를 입력하세요",
      "verification_code": "보내기",
      "reSend": "다시 보내기",
      "sending": "보내는 중"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24 시간",
          "desc": "업로드 후 24시간 만료"
        },
        {
          "id": "43200",
          "name": "12시간",
          "desc": "업로드 후 12시간 후 만료"
        },
        {
          "id": "7200",
          "name": "2 시간",
          "desc": "업로드 후 2시간 만료"
        },
        {
          "id": "1800",
          "name": "30 분",
          "desc": "업로드 후 30분 만료"
        }
      ],
      "current_device": "현재 장치 이름",
      "choose_device": "장치 선택",
      "choose_paper_import": "paper 유형 선택",
      "choose_language": "언어 선택",
      "exit": "종료",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
    "other_name": "기타",
      "name": "이름",
      "type": "유형",
      "size": "크기",
      "time": "만료 시간",
      "operation": "작업",
      "download": "다운로드",
      "delete": "삭제",
      "import": "가져오기",
      "return": "이전으로 돌아가기",
      "search_all": "모든 파일 검색",
      "selected": "",
      "selected_file": "선택한 파일/폴더",
      "file": "파일",
      "folder": "폴더",
      "no_data": "데이터 없음",
      "confirm_delete": "삭제 확인",
      "confirm_delete_file": "파일을 삭제하시겠습니까? 확인하시겠습니까?",
      "send_to": "목록 가져오기",
      "download_list": "다운로드 목록",
      "device_number": "장치 번호",
      "scan": "QR 코드를 스캔하거나 주소를 입력하세요",
      "share": "공유",
      "download_code": "다운로드",
      "copy_link": "링크 복사",
      "share_tips": "참고: 공유 링크/QR 코드는 24시간 동안 유효합니다",
      "choose_format": "형식 선택",
      "please_choose_format": "형식을 선택해주세요",
      "format_not_exists": "해당 형식이 존재하지 않습니다",
      "copy_success": "복사 성공",
      "copy_fail": "복사 실패",
      "close_download_tips": "다운로드 중인 파일이 있어 목록을 닫을 수 없습니다.",
      "choose_send_device": "장치를 선택하세요",
      "send_success": "동기화 성공",
      "send_fail": "동기화 실패",
      "cancel": "취소",
      "ok": "확인",
      "send": "동기화",
      "no_device": "기계에 다시 로그인하여 장치를 자동으로 추가하세요",
      "current_no_device": "장치 없음",
      "current_device_tips": "현재 장치",
      "send_loading_text": "동기화 중",
      "loading_text": "로드 중",
      "send_error": "동기화 실패",
      "try_download": "다시 시도",
      "downloading": "다운로드 중",
      "error": "서버 오류",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "참고: 사용자 데이터의 개인 정보 및 보안을 위해 업로드된 파일은 %s 후에 자동으로 삭제됩니다.",
      "sync": "동기화",
      "max_size": "파일 크기가 100MB를 초과하여 업로드할 수 없습니다.",
      "file_time": "파일이 만료됩니다",
      "language": "언어",
      "device_name": "장치 이름",
      "support_png": "png 형식만 지원",
      "share_to": "링크 복사 성공, 빨리 친구에게 공유!",
      "create_code": "QR코드 생성",
      "so": "파일 기다리기",
      "valid": "링크 / QR코드 유효기간은 12시간",
      "download_phone": "휴대폰으로 다운로드",
      "yes": "알았어",
      "format_error": "이 형식의 파일은 지원되지 않습니다",
      "source": "출처",
      "apk_share": "공유",
      "export": "내보내기",
      "sync_desc": "동기화 설명",
      "sync_detail": "\"아이페이퍼 내보내기(ViTransfer > 내보내기)\"에서 나온 파일은 동기화를 지원하지만, \"아이페이퍼 공유\"의 파일은 동기화를 지원하지 않습니다.",
      "confirm_exit": "로그아웃하시겠습니까?",
      "exit_logo": "비밀번호가 변경되었습니다. 다시 로그인해 주세요.",
    "picture_name": "사진",
    },
    "trashLabel": "휴지통"
  },
  "pt": {
    "appUi": {
      "myFiles": "Meus arquivos",
      "all": "Tudo",
      "allSources": "Todas as fontes",
      "favorite": "Favoritos",
      "recentDeleted": "Excluídos recentemente",
      "search": "Pesquisar",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "Importar modelo",
      "importData": "Importar dados",
      "importBooks": "Importar livros",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "Sem dados",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "Cancelar",
      "ok": "OK",
      "more": "More",
      "download": "Baixar",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "Voltar",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "Fechar",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "Escolher formato",
      "notice": "Notice",
      "loading": "Carregando",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "O tamanho do arquivo excede o limite de 500 MB.",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "Tentar novamente",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "Hoje",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "Dom",
        "Seg",
        "Ter",
        "Qua",
        "Qui",
        "Sex",
        "Sáb"
      ]
    },
    "login": {
      "login_account": "Entrar na conta",
      "email": "E-mail",
      "phone": "Telefone",
      "forget_password": "Esqueceu a senha",
      "login": "Entrar",
      "email_error": "Erro de e-mail",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "Digite seu e-mail",
      "phone_tips": "Digite seu telefone",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Atualize a senha ou registre-se em um dispositivo Viwoods",
      "return_login": "Voltar",
      "password_reqired": "Senha obrigatoria",
      "email_reqired": "E-mail obrigatorio",
      "phone_reqired": "Telefone obrigatorio",
      "please_choose": "Codigo",
      "please_choose_area": "Escolha o codigo de area",
      "sms_login": "Login com codigo",
      "password_login": "Login com senha",
      "verification_tips": "Digite o codigo SMS",
      "enter_password_tips": "Digite sua senha",
      "verification_code": "Enviar",
      "reSend": "Reenviar",
      "sending": "Enviando"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24 Horas",
          "desc": "Expira 24 horas após o upload"
        },
        {
          "id": "43200",
          "name": "12 horas",
          "desc": "Expira 12 horas após o upload"
        },
        {
          "id": "7200",
          "name": "2 Horas",
          "desc": "Expira 2 horas após o upload"
        },
        {
          "id": "1800",
          "name": "30 Minutos",
          "desc": "Expira 30 minutos após o upload"
        }
      ],
      "current_device": "nome do dispositivo atual",
      "choose_device": "escolher dispositivo",
      "choose_paper_import": "escolha o tipo de Paper para importação",
      "choose_language": "escolher idioma",
      "exit": "Sair",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
      "other_name": "Outro",
      "name": "Nome",
      "type": "Tipo",
      "size": "Tamanho",
      "time": "Data de expiração",
      "operation": "Operação",
      "download": "Download",
      "delete": "Excluir",
      "import": "Importar",
      "return": "Retorno Pré",
      "search_all": "Pesquisar todos os arquivos",
      "selected": "",
      "selected_file": "arquivos/pastas selecionados",
      "file": "arquivo",
      "folder": "pasta",
      "no_data": "sem dados",
      "confirm_delete": "confirmar exclusão",
      "confirm_delete_file": "confirmar exclusão do arquivo?",
      "send_to": "lista de importação",
      "download_list": "lista de download",
      "device_number": "número do dispositivo",
      "scan": "Escanear o código ou inserir o endereço",
      "share": "Compartilhar",
      "download_code": "Download",
      "copy_link": "Copiar Link",
      "share_tips": "Observação: o link/QR Code compartilhado é válido por 24 horas",
      "choose_format": "escolher formato",
      "please_choose_format": "Por favor, escolha o formato",
      "format_not_exists": "O formato não existe",
      "copy_success": "Copia bem-sucedida",
      "copy_fail": "Copia falhou",
      "close_download_tips": "Há arquivos sendo baixados e a lista não pode ser fechada.",
      "choose_send_device": "por favor, escolha o dispositivo de sincronização",
      "send_success": "Sincronização bem-sucedida",
      "send_fail": "Falha na sincronização",
      "cancel": "Cancelar",
      "ok": "Confirmar",
      "send": "Sincronizar",
      "no_device": "Por favor, faça login novamente na máquina para adicionar automaticamente o dispositivo",
      "current_no_device": "sem dispositivo",
      "current_device_tips": "dispositivo atual",
      "send_loading_text": "Sincronizando",
      "loading_text": "Carregando",
      "send_error": "falha na sincronização",
      "try_download": "tentar novamente",
      "downloading": "baixando",
      "error": "erro de servidor",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "Observação: para garantir a privacidade e a segurança dos dados do usuário, os arquivos enviados serão automaticamente apagados após %s.",
      "sync": "Sincronizar",
      "max_size": "O tamanho do arquivo excede 100 MB e não pode ser enviado.",
      "file_time": "Arquivo Expira em",
      "language": "Língua",
      "device_name": "Nome do dispositivo",
      "support_png": "Suporta apenas o formato PNG.",
      "share_to": "O link foi copiado com sucesso, compartilhe com seus amigos!",
      "create_code": "Gerar código 2D",
      "so": "Arquivos à espera",
      "valid": "Link/código 2D válido por 12 horas",
      "download_phone": "Baixar para o celular",
      "yes": "Eu percebi.",
      "format_error": "Arquivos com este formato não suportados",
      "source": "Fonte",
      "apk_share": "Compartilhar",
      "export": "Exportar",
      "sync_desc": "instruções de sincronização",
      "sync_detail": "Arquivos originados de \"AiPaper Exportar (ViTransfer > Exportar)\" suportam sincronização, enquanto arquivos de \"Compartilhar AiPaper\" não suportam sincronização.",
      "confirm_exit": "Tem certeza de que deseja sair?",
      "exit_logo": "A senha foi alterada. Por favor, faça login novamente.",
      "picture_name": "Imagem"
    },
    "trashLabel": "Lixeira"
  },
  "ru": {
    "appUi": {
      "myFiles": "Мои файлы",
      "all": "Все",
      "allSources": "\u0412\u0441\u0435 \u0438\u0441\u0442\u043e\u0447\u043d\u0438\u043a\u0438",
      "favorite": "Избранное",
      "recentDeleted": "Недавно удаленные",
      "search": "Поиск",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "Импорт шаблона",
      "importData": "Импорт данных",
      "importBooks": "Импорт книг",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "Нет данных",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "Отмена",
      "ok": "OK",
      "more": "More",
      "download": "Скачать",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "Назад",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "Закрыть",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "Выбрать формат",
      "notice": "Notice",
      "loading": "Загрузка",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "Размер файла превышает ограничение в 500 МБ.",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "Повторить",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "Сегодня",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "Вс",
        "Пн",
        "Вт",
        "Ср",
        "Чт",
        "Пт",
        "Сб"
      ]
    },
    "login": {
      "login_account": "Вход в аккаунт",
      "email": "E-mail",
      "phone": "Телефон",
      "forget_password": "Забыли пароль",
      "login": "Войти",
      "email_error": "Ошибка e-mail",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "Введите e-mail",
      "phone_tips": "Введите телефон",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Измените пароль или зарегистрируйтесь на устройстве Viwoods",
      "return_login": "Назад",
      "password_reqired": "Пароль обязателен",
      "email_reqired": "E-mail обязателен",
      "phone_reqired": "Телефон обязателен",
      "please_choose": "Код",
      "please_choose_area": "Выберите код",
      "sms_login": "Вход по коду",
      "password_login": "Вход по паролю",
      "verification_tips": "Введите SMS-код",
      "enter_password_tips": "Введите пароль",
      "verification_code": "Отправить",
      "reSend": "Отправить снова",
      "sending": "Отправка"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24 часа",
          "desc": "Действительно в течение 24 часов после загрузки"
        },
        {
          "id": "43200",
          "name": "12 часов",
          "desc": "Действительно в течение 12 часов после загрузки"
        },
        {
          "id": "7200",
          "name": "2 часа",
          "desc": "Действительно в течение 2 часов после загрузки"
        },
        {
          "id": "1800",
          "name": "30 минут",
          "desc": "Действительно в течение 30 минут после загрузки"
        }
      ],
      "current_device": "Текущее устройство",
      "choose_device": "Выбрать устройство",
      "choose_paper_import": "Выбрать тип импорта",
      "choose_language": "Выбрать язык",
      "exit": "Выйти",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
    "other_name": "Другое",
      "name": "Название",
      "type": "Тип",
      "size": "Размер",
      "time": "Срок истечения",
      "operation": "Действие",
      "download": "Скачать",
      "delete": "Удалить",
      "del": "Удалить",
      "import": "Импорт",
      "return": "Вернуться на предыдущий уровень",
      "search_all": "Поиск всех файлов",
      "selected": "Выбрано",
      "selected_file": "файлов/папок",
      "file": "Файл",
      "folder": "Папка",
      "no_data": "Нет данных",
      "confirm_delete": "Подтвердите удаление",
      "confirm_delete_file": "Вы уверены, что хотите удалить файл?",
      "device_number": "Серийный номер",
      "send_to": "Список импорта",
      "download_list": "Список загрузок",
      "scan": "Сканируйте или введите адрес",
      "share": "Поделиться",
      "download_code": "QR-код для загрузки",
      "copy_link": "Копировать ссылку",
      "share_tips": "Примечание: Срок действия ссылки/QR-кода составляет 12 часов",
      "choose_format": "Выбрать формат",
      "please_choose": "Пожалуйста, выберите папку или файл",
      "please_choose_format": "Пожалуйста, выберите формат",
      "format_not_exists": "Файл в данном формате не существует",
      "copy_success": "Копирование успешно",
      "copy_fail": "Ошибка копирования",
      "close_download_tips": "Нельзя закрыть список, пока идет загрузка файлов.",
      "choose_send_device": "Пожалуйста, выберите устройство для синхронизации",
      "send_success": "Синхронизация успешна",
      "send_fail": "Ошибка синхронизации",
      "cancel": "Отмена",
      "ok": "Подтвердить",
      "send": "Синхронизировать",
      "no_device": "Нет устройств. Пожалуйста, войдите на устройстве, чтобы оно автоматически добавилось.",
      "current_no_device": "Нет доступных устройств",
      "current_device_tips": "Текущее устройство",
      "send_loading_text": "Синхронизация",
      "loading_text": "Загрузка",
      "send_error": "Сбой синхронизации",
      "try_download": "Повторить",
      "downloading": "Загрузка",
      "error": "Ошибка сервиса",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "Подсказка: Для обеспечения конфиденциальности данные будут автоматически удалены через %s.",
      "sync": "Синхронизация",
      "max_size": "Размер файла не должен превышать 400 МБ",
      "file_time": "Время действия файла",
      "language": "Язык",
      "device_name": "Имя устройства",
      "support_png": "Поддерживается только формат PNG",
      "share_to": "Ссылка успешно скопирована! Поделитесь с друзьями!",
      "create_code": "Создать QR-код",
      "so": "и другие файлы",
      "valid": "Срок действия ссылки/QR-кода — 12 часов",
      "download_phone": "Скачать на телефон",
      "yes": "Понятно",
      "format_error": "Этот формат файла не поддерживается",
      "source": "Источник файла",
      "apk_share": "Поделиться",
      "export": "Экспорт",
      "sync_desc": "Описание синхронизации",
      "sync_detail": "Файлы, экспортированные из 'AiPaper (ViTransfer > Экспорт)', поддерживают синхронизацию. Файлы, созданные через 'AiPaper Поделиться', не поддерживают синхронизацию.",
      "confirm_exit": "Вы уверены, что хотите выйти из аккаунта?",
      "exit_logo": "La password è stata modificata. Si prega di effettuare nuovamente l'accesso.",
    "picture_name": "Изображение"
    },
    "trashLabel": "Корзина"
  },
  "es": {
    "appUi": {
      "myFiles": "Mis archivos",
      "all": "Todo",
      "allSources": "Todas las fuentes",
      "favorite": "Favoritos",
      "recentDeleted": "Eliminados recientemente",
      "search": "Buscar",
      "createFolder": "New folder",
      "importPdf": "Import PDF",
      "importTemplate": "Importar plantilla",
      "importData": "Importar datos",
      "importBooks": "Importar libros",
      "upload": "Upload",
      "modifyTime": "Modified",
      "createTime": "Created",
      "name": "Name",
      "desc": "Descending",
      "asc": "Ascending",
      "listView": "List view",
      "gridView": "Grid view",
      "empty": "Sin datos",
      "item": "item",
      "page": "page",
      "selectedPrefix": "Selected",
      "selectedSuffix": "items",
      "cancel": "Cancelar",
      "ok": "OK",
      "more": "More",
      "download": "Descargar",
      "rename": "Rename",
      "move": "Move",
      "encrypt": "Encrypt",
      "decrypt": "Decrypt",
      "encrypted": "Encrypted",
      "unfavorite": "Remove favorite",
      "delete": "Delete",
      "back": "Atrás",
      "recordings": "Recordings",
      "allRecordings": "All recordings",
      "transcript": "Transcript",
      "pageGrid": "Page grid",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "close": "Cerrar",
      "expand": "Expand",
      "collapse": "Collapse",
      "open": "Open",
      "clear": "Clear",
      "downloadList": "Downloads",
      "uploadList": "Uploads",
      "chooseFormat": "Elegir formato",
      "notice": "Notice",
      "loading": "Cargando",
      "uploading": "Uploading",
      "uploadDone": "Upload complete",
      "uploadFailed": "Upload failed",
      "continueUpload": "Continue upload",
      "uploadFileSizeLimit": "El tamaño del archivo supera el límite de 500 MB.",
      "uploadTypeNotSupported": "This file format is not supported.",
      "loadFailed": "Failed to load",
      "detailLoadFailed": "Failed to parse. Please try again.",
      "dataLoadFailed": "{app} data failed to load. Please try again later.",
      "retry": "Reintentar",
      "passwordTitle": "Enter password",
      "passwordPlaceholder": "Please enter the password",
      "passwordHide": "Hide password",
      "passwordShow": "Show password",
      "passwordConfirming": "Verifying",
      "passwordRequired": "Please enter the password",
      "passwordWrong": "Incorrect password. Please try again.",
      "passwordCryptoUnsupported": "Password encryption is not supported in this browser.",
      "verifying": "Verifying",
      "readingProgress": "Reading progress",
      "noReadingProgress": "No reading progress",
      "bookmarks": "Bookmarks",
      "highlights": "Highlights",
      "annotations": "Handwritten notes",
      "noBookmarks": "No bookmarks",
      "noHighlights": "No highlights",
      "noAnnotations": "No handwritten notes",
      "noTranscript": "No transcript available.",
      "transcriptLoading": "Transcript loading...",
      "transcriptPending": "The transcript file has been returned. Its content will be shown after the official API is ready.",
      "chooseDownloadableFile": "Please select a downloadable file",
      "foldersNotDownloadable": "Folders and templates cannot be downloaded. Please select a file",
      "downloadPreparing": "Preparing download",
      "downloading": "Downloading",
      "downloadDone": "Download complete",
      "downloadFailed": "Download failed",
      "savingFile": "Saving file",
      "generatingPdf": "Generating PDF",
      "packingZip": "Packing ZIP",
      "continueDownload": "Continue download",
      "imageReadFailed": "Image read failed. Click to retry",
      "maxBatchDownload": "A single download operation cannot exceed {count} files.",
      "maxRunningDownload": "Only up to {count} downloads can run at the same time. Please wait for some tasks to finish.",
      "fakeTip": "This API is not available yet.",
      "today": "Hoy",
      "todo": "To-do",
      "tasks": "Tasks",
      "notes": "Notes",
      "month": "Month",
      "week": "Week",
      "day": "Day",
      "allDay": "All day",
      "allStatus": "All status",
      "finished": "Finished",
      "unfinished": "Unfinished",
      "dailyDateFormat": "{year}-{month}-{day}",
      "yearFormat": "{year}",
      "monthFormat": "{month}",
      "weekdays": [
        "Dom",
        "Lun",
        "Mar",
        "Mié",
        "Jue",
        "Vie",
        "Sáb"
      ]
    },
    "login": {
      "login_account": "Cuenta de inicio",
      "email": "Correo",
      "phone": "Telefono",
      "forget_password": "Olvide la contrasena",
      "login": "Iniciar sesion",
      "email_error": "Error de correo",
      "password_error": "Please enter a password of at least 8 characters",
      "email_tips": "Introduce tu correo",
      "phone_tips": "Introduce tu telefono",
      "password_tips": "Please enter a password of at least 8 characters",
      "update_password_tips": "Actualiza la contrasena o registrate en un dispositivo Viwoods",
      "return_login": "Volver",
      "password_reqired": "Contrasena requerida",
      "email_reqired": "Correo requerido",
      "phone_reqired": "Telefono requerido",
      "please_choose": "Codigo",
      "please_choose_area": "Elige el codigo de area",
      "sms_login": "Inicio con codigo",
      "password_login": "Inicio con contrasena",
      "verification_tips": "Introduce el codigo SMS",
      "enter_password_tips": "Introduce tu contrasena",
      "verification_code": "Enviar",
      "reSend": "Reenviar",
      "sending": "Enviando"
    },
    "vitransfer": {
      "timeList": [
        {
          "id": "86400",
          "name": "24 Horas",
          "desc": "Caduca 24 horas después de la subida"
        },
        {
          "id": "43200",
          "name": "12 Horas",
          "desc": "Caduca 12 horas después de la subida"
        },
        {
          "id": "7200",
          "name": "2 horas",
          "desc": "Caduca 2 horas después de la subida"
        },
        {
          "id": "1800",
          "name": "30 minutos",
          "desc": "Caduca 30 minutos después de la subida"
        }
      ],
      "current_device": "nombre del dispositivo actual",
      "choose_device": "elegir dispositivo",
      "choose_paper_import": "elegir tipo de papel de importación",
      "choose_language": "elegir idioma",
      "exit": "Salir ",
      "paper_name": "Paper",
      "meeting_name": "Meeting",
      "learning_name": "Learning",
      "knowledge_name": "Knowledge Base",
      "picking_name": "Picking",
      "memo_name": "Memo",
      "daily_name": "Daily",
      "other_name": "Otro",
      "name": "Nombre",
      "type": "Tipo",
      "size": "Tamaño",
      "time": "Fecha de vencimiento",
      "operation": "Funcionamiento",
      "download": "Descargar",
      "delete": "Eliminar",
      "import": "Importar",
      "return": "Volver Pre",
      "search_all": "Buscar todo el archivo",
      "selected": "",
      "selected_file": "archivos/carpetas seleccionados",
      "file": "archivo",
      "folder": "carpeta",
      "no_data": "sin datos",
      "confirm_delete": "confirmar eliminar",
      "confirm_delete_file": "¿Confirmar eliminar archivo？",
      "send_to": "importar lista",
      "download_list": "descargar lista",
      "device_number": "número de dispositivo",
      "scan": "Escanea el código o introduce la dirección",
      "share": "Compartir",
      "download_code": "Descargar",
      "copy_link": "Copiar Enlace",
      "share_tips": "Nota: El enlace compartido/código QR es válido durante 24 horas",
      "choose_format": "elegir formato",
      "please_choose_format": "Por favor, elige el formato",
      "format_not_exists": "El formato no existe",
      "copy_success": "Copia exitosa",
      "copy_fail": "Fallo al copiar",
      "close_download_tips": "Se están descargando archivos y no se puede cerrar la lista.",
      "choose_send_device": "Por favor, elige el dispositivo de sincronización",
      "send_success": "Sincronización exitosa",
      "send_fail": "Fallo al sincronizar",
      "cancel": "Cancelar",
      "ok": "Confirma",
      "send": "Sincronizar",
      "no_device": "Por favor, inicia sesión de nuevo en la máquina para añadir automáticamente el dispositivo",
      "current_no_device": "ningún dispositivo",
      "current_device_tips": "dispositivo actual",
      "send_loading_text": "Sincronización",
      "loading_text": "Cargando",
      "send_error": "fallo al sincronizar",
      "try_download": "reintentar",
      "downloading": "descargando",
      "error": "error del servidor",
      "support_learning": "PDF、EPUB、AZW/AZW3、MOBI",
      "support_meeting": "PNG、JPG",
      "support_paper": "PDF、JPG",
      "outTime": "Nota: Para garantizar la privacidad y seguridad de los datos de los usuarios, los archivos cargados se borrarán automáticamente después de %s.",
      "sync": "Sincronizar",
      "max_size": "El tamaño del archivo supera los 400MB y no se puede subir.",
      "file_time": "El Archivo Caduca en",
      "language": "Idioma",
      "device_name": "Nombre del equipo",
      "support_png": "Solo se admite el formato png",
      "share_to": "El enlace se copió con éxito, ¡ comparte con tus amigos!",
      "create_code": "Generar Código qr",
      "so": "Esperar documentos",
      "valid": "El período de validez del enlace / código QR es de 12 horas",
      "download_phone": "Descargar al teléfono móvil",
      "yes": "Lo tengo",
      "format_error": "Archivos que no admiten este formato",
      "source": "Fuente",
      "apk_share": "compartir",
      "export": "exportar",
      "sync_desc": "instrucciones de sincronización",
      "sync_detail": "Los archivos provenientes de \"AiPaper Exportar (ViTransfer > Exportar)\" admiten la sincronización, mientras que los archivos de \"Compartir AiPaper\" no admiten la sincronización.",
      "confirm_exit": "¿Confirmas que deseas cerrar sesión?",
      "exit_logo": "Le mot de passe a été changé. Veuillez vous reconnecter.",
      "picture_name": "Imagen"
    },
    "trashLabel": "Papelera"
  }
}

export const APP_UI_TEXTS = Object.fromEntries(Object.entries(LANGUAGE_PACKS).map(([language, pack]) => [language, pack.appUi]))
export const LOGIN_LANGUAGE = Object.fromEntries(Object.entries(LANGUAGE_PACKS).map(([language, pack]) => [language, pack.login]))
export const VITRANSFER_LANGUAGE = Object.fromEntries(Object.entries(LANGUAGE_PACKS).map(([language, pack]) => [language, pack.vitransfer]))
export const TRASH_LABELS = Object.fromEntries(Object.entries(LANGUAGE_PACKS).map(([language, pack]) => [language, pack.trashLabel]))
